import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as _ from 'lodash';
import { Grid } from '@mui/material';
import GemGPTChatBox from './GemGPTChatBox/GemGPTChatBox';
import GemGPTChatHistory from './GemGPTChatHistory/GemGPTChatHistory';
import CustomLoader from '../../components/CustomLoader/CustomLoader';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { gemGPTActions } from '../../redux/gemGPT/gemGPTslice';
import DeleteOrCreateNewChatModal from './DeleteORCReateNewChatModal/DeleteORCReateNewChatModal';

const GemGPT = () => {
  const [open, setOpen] = React.useState(false);
  const [chatInfo, setChatInfo] = React.useState({ chatTitle: '', chatTimestamp: '' });
  const [isDeleteChat, setIsDeleteChat] = React.useState(false);
  const { chatData, chatHistories, componentStatus, selectedChatId } = useAppSelector(
    (state: RootState) => state.gemGPT,
  );
  const getGemGPTChatDataLoading = Boolean(_.get(componentStatus, 'getGemGPTChatDataLoading', false));
  const createNewChatLoading = Boolean(_.get(componentStatus, 'createNewChatLoading', false));
  const deleteChatLoading = Boolean(_.get(componentStatus, 'deleteChatLoading', false));

  const getGemGPTChatHistoryListDataLoading = Boolean(
    _.get(componentStatus, 'getGemGPTChatHistoryListDataLoading', false),
  );
  const dispatch = useDispatch();

  const handleSelectOption = (chatId: string) => {
    if (chatId) {
      dispatch(gemGPTActions.setSelectedChatId(chatId));
    }
  };

  const handleUserInput = (userInput: string) => {
    if (userInput) {
      dispatch(gemGPTActions.getGemGPTResponse(userInput));
    }
  };
  const handleOpenDeleteOrCreateNewChatModel = (isDeleteChatTrue: boolean) => {
    if (isDeleteChatTrue) {
      const result = chatHistories
        .find((chatHistory) => chatHistory.chatHistory.some((chat) => chat.chatId === selectedChatId))
        ?.chatHistory.find((chat) => chat.chatId === selectedChatId);

      if (result) {
        setChatInfo({ chatTitle: result.chatTitle, chatTimestamp: result.chatTimestamp });
        setIsDeleteChat(true);
        setOpen(true);
      }
      return;
    }
    setIsDeleteChat(false);
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleDeleteChat = () => {
    dispatch(gemGPTActions.deleteChat(selectedChatId));
    setOpen(false);
  };
  const handleCreateNewChat = (text: string) => {
    dispatch(gemGPTActions.createNewChat(text));
    setOpen(false);
  };

  const handleConfirm = (text: string = '') => {
    if (isDeleteChat) {
      handleDeleteChat();
      return;
    }
    handleCreateNewChat(text);
  };

  useEffect(() => {
    dispatch(gemGPTActions.getGemGPTChatHistoriesData());
  }, []);

  useEffect(() => {
    if (!getGemGPTChatHistoryListDataLoading) {
      dispatch(gemGPTActions.getGemGPTChatData(selectedChatId));
    }
  }, [selectedChatId, getGemGPTChatHistoryListDataLoading, createNewChatLoading, deleteChatLoading]);

  return (
    <>
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          padding: '20px 10px',
        }}
      >
        <Grid item xs={2} sm={2.5}>
          {getGemGPTChatHistoryListDataLoading ? (
            <CustomLoader />
          ) : (
            <GemGPTChatHistory
              selectedChatId={selectedChatId}
              chatHistoryList={chatHistories}
              handleSelectOption={handleSelectOption}
              handleDeleteChat={() => {
                handleOpenDeleteOrCreateNewChatModel(true);
              }}
              handleCreateNewChat={() => {
                handleOpenDeleteOrCreateNewChatModel(false);
              }}
            />
          )}
        </Grid>
        <Grid
          item
          xs={10}
          sm={9.5}
          sx={{
            backgroundColor: '#F6F7F9',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            padding: '10px',
            borderRadius: '12px',
          }}
        >
          {getGemGPTChatDataLoading ? (
            <CustomLoader />
          ) : (
            <GemGPTChatBox handleUserInput={handleUserInput} chatData={chatData} />
          )}
        </Grid>
      </Grid>

      <DeleteOrCreateNewChatModal
        open={open}
        isDeleteChat={isDeleteChat}
        onClose={handleCancel}
        onConfirm={(text) => handleConfirm(text)}
        chatData={chatInfo}
      />
    </>
  );
};

export default GemGPT;
